
import { Facebook, Instagram, Linkedin, Twitter } from "lucide-react";
import { useEffect, useState } from "react";
import { useMobileBrowser } from "@/hooks/use-mobile-browser";
import { toast } from "@/components/ui/use-toast";

const FooterSocialLinks = () => {
  const { isMobile, browserType, isInstagramWebView, isFacebookWebView } = useMobileBrowser();
  const [links] = useState({
    facebook: "https://facebook.com/armpitscom",
    instagram: "https://instagram.com/armpitscom",
    linkedin: "https://linkedin.com/company/armpits",
    twitter: "https://twitter.com/armpits_com"
  });

  // Special handler for social media links in webviews
  const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>, platform: string) => {
    if (isInstagramWebView || isFacebookWebView) {
      console.log(`Handling ${platform} link click in social media webview`);
      e.preventDefault();
      
      // Show toast and copy link to clipboard instead
      const linkText = links[platform as keyof typeof links];
      
      // Copy to clipboard
      const textArea = document.createElement('textarea');
      textArea.value = linkText;
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      
      try {
        document.execCommand('copy');
        toast({
          title: "Link copied!",
          description: `The ${platform} link has been copied to your clipboard.`,
          duration: 3000,
        });
      } catch (err) {
        toast({
          title: "Couldn't copy link",
          description: "Please copy the link manually.",
          duration: 3000,
        });
      }
      
      document.body.removeChild(textArea);
      return false;
    }
  };

  return (
    <div className="flex space-x-4">
      <a 
        href={links.facebook}
        rel="noreferrer noopener"
        target="_blank"
        aria-label="Visit our Facebook page"
        className="text-foreground hover:text-primary transition-colors"
        data-ssl-safe="true"
        onClick={(e) => handleLinkClick(e, 'facebook')}
      >
        <Facebook className="w-5 h-5" />
        <span className="sr-only">Facebook</span>
      </a>
      <a 
        href={links.instagram}
        rel="noreferrer noopener"
        target="_blank"
        aria-label="Visit our Instagram page"
        className="text-foreground hover:text-primary transition-colors"
        data-ssl-safe="true"
        onClick={(e) => handleLinkClick(e, 'instagram')}
      >
        <Instagram className="w-5 h-5" />
        <span className="sr-only">Instagram</span>
      </a>
      <a 
        href={links.linkedin}
        rel="noreferrer noopener"
        target="_blank"
        aria-label="Visit our LinkedIn page"
        className="text-foreground hover:text-primary transition-colors"
        data-ssl-safe="true"
        onClick={(e) => handleLinkClick(e, 'linkedin')}
      >
        <Linkedin className="w-5 h-5" />
        <span className="sr-only">LinkedIn</span>
      </a>
      <a 
        href={links.twitter}
        rel="noreferrer noopener"
        target="_blank"
        aria-label="Visit our Twitter page"
        className="text-foreground hover:text-primary transition-colors"
        data-ssl-safe="true"
        onClick={(e) => handleLinkClick(e, 'twitter')}
      >
        <Twitter className="w-5 h-5" />
        <span className="sr-only">Twitter</span>
      </a>
    </div>
  );
};

export default FooterSocialLinks;
